import { render, staticRenderFns } from "./inviteMember.vue?vue&type=template&id=33f65e40&scoped=true"
import script from "./inviteMember.vue?vue&type=script&lang=js"
export * from "./inviteMember.vue?vue&type=script&lang=js"
import style0 from "./inviteMember.vue?vue&type=style&index=0&id=33f65e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f65e40",
  null
  
)

export default component.exports